import { concat } from '../observable/concat';
import { of } from '../observable/of';
export function endWith(...values) {
  return source => concat(source, of(...values));
}
